import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRockingHorse: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rocking-horse, child, kids, toy"><path d="M2.75 12.4999V11.75C2.75 10.0931 4.09315 8.75 5.75 8.75H11.9932C14 4 16 2.75 19.1824 2.75L21.75 7.5L20.2095 9L18.1554 8L17 10L19.5 19" stroke="currentColor" strokeWidth="1.5"/><path d="M7 9L4.5 19" stroke="currentColor" strokeWidth="1.5"/><path d="M7.5 20L10 14.75H14L16.5 20" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 18C8.88423 22.3333 15.1158 22.3333 21.25 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRockingHorse;
